// @flow

/**
 * Copied from https://gist.github.com/penguinboy/762197.
 */
/* eslint-disable */
export const flattenObject = function (ob: { ... }): { ... } {
  var toReturn: {
    [key: string]: any,
  } = {};

  for (var i in ob) {
    if (!ob.hasOwnProperty(i)) continue;

    // $FlowFixMe[invalid-computed-prop]
    if (typeof ob[i] == 'object') {
      var flatObject = flattenObject(ob[i]);
      for (var x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;

        // $FlowFixMe[invalid-computed-prop]
        toReturn[i + '.' + x] = flatObject[x];
      }
    } else {
      toReturn[i] = ob[i];
    }
  }
  return toReturn;
};
/* eslint-enable */
